import React from 'react';
import { useTheme } from '../context/ThemeContext';

export default function PrivacyPolicy() {
  const { currentColors } = useTheme();

  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="glass-card p-8">
        <h1 className="text-3xl font-cinzel mb-6" style={{ color: currentColors.primary }}>
          Privacy Policy
        </h1>
        <p className="text-sm mb-6" style={{ color: currentColors.textMuted }}>
          Last updated: February 2025
        </p>

        <div className="space-y-6" style={{ color: currentColors.text }}>
          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              1. Introduction
            </h2>
            <p>
              Welcome to The Aura Space ("we," "our," or "us"). We are committed to protecting your privacy 
              and personal information. This Privacy Policy explains how we collect, use, disclose, and 
              safeguard your information when you use our mindfulness and holistic healing platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              2. Information We Collect
            </h2>
            <h3 className="font-medium mb-2">Personal Information</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name and email address when you create an account</li>
              <li>Profile information you choose to provide</li>
              <li>Journal entries and mood tracking data</li>
              <li>Meditation and session history</li>
            </ul>
            
            <h3 className="font-medium mb-2 mt-4">Social Media Information</h3>
            <p>
              When you connect your social media accounts (Facebook, Instagram), we may receive:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Your public profile information</li>
              <li>Pages you manage (for posting purposes)</li>
              <li>Access tokens to post on your behalf</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              3. How We Use Your Information
            </h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To provide and maintain our services</li>
              <li>To personalize your experience</li>
              <li>To send you notifications and updates</li>
              <li>To post content to social media on your behalf (only when you authorize)</li>
              <li>To improve our platform and develop new features</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              4. Data Sharing
            </h2>
            <p>
              We do not sell your personal information. We may share your data with:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Service providers who assist in our operations</li>
              <li>Social media platforms (only for posting when you authorize)</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              5. Data Security
            </h2>
            <p>
              We implement appropriate security measures to protect your personal information, including:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Encryption of data in transit and at rest</li>
              <li>Secure password hashing</li>
              <li>Two-factor authentication options</li>
              <li>Regular security audits</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              6. Your Rights
            </h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Delete your account and data</li>
              <li>Disconnect social media accounts</li>
              <li>Export your data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              7. Data Deletion
            </h2>
            <p>
              You can request deletion of your data at any time by visiting our{' '}
              <a href="/data-deletion" style={{ color: currentColors.secondary }}>
                Data Deletion page
              </a>{' '}
              or contacting us at support@theaura-space.com.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              8. Cookies
            </h2>
            <p>
              We use cookies and similar technologies to enhance your experience, 
              remember your preferences, and analyze platform usage.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              9. Contact Us
            </h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className="mt-2">
              Email: support@theaura-space.com<br />
              Website: <a href="/contact" style={{ color: currentColors.secondary }}>Contact Form</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3" style={{ color: currentColors.primary }}>
              10. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any 
              changes by posting the new Privacy Policy on this page and updating the 
              "Last updated" date.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
